import React, { Suspense } from 'react';

import BuyTicket from './BuyTicket'; // Grupo de WhatsApp

const Banner = React.lazy(() => import('./Banner')); // Eventos destacados - Banner (Plata)
const SlidingText = React.lazy(() => import('./SlidingText')); // Eventos destacados - Texto deslizable
const EventOne = React.lazy(() => import('./EventOne')); // Eventos destacados - Latido Estelar (Oro)
const TeamOne = React.lazy(() => import('./TeamOne')); // Talentos (Plata)
const GalleryOne = React.lazy(() => import('./GalleryOne')); // Galeria (Plata)
const ScheduleOne = React.lazy(() => import('./ScheduleOne')); // Eventos Home (Bronce)
const BrandOne = React.lazy(() => import('./BrandOne')); // Marcas destacadas - Imagenes deslizable
const BlogOne = React.lazy(() => import('./BlogOne')); // Efemerides

const HomeMain = () => {
	return (
		<React.Fragment>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<Banner />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<SlidingText />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<EventOne />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<TeamOne />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<GalleryOne />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<ScheduleOne />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<BrandOne />
			</Suspense>
			<Suspense fallback={<div>Cargando componente...</div>}>
				<BlogOne />
			</Suspense>
			<BuyTicket />
		</React.Fragment>
	);
}

export default HomeMain;